module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "summary-layout"
  }, [_c('table', {
    staticClass: "table table-fixed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.filteredData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.server))]), _c('td', [_vm._v(_vm._s(data.cmp1_time))]), _c('td', [_vm._v(_vm._s(data.cmp2_time))]), _c('td', [_vm._v(_vm._s(data.check_status))])])
  }), 0)])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('QueryFilter', {
    attrs: {
      "showReportButton": _vm.showReportButton,
      "showDate": _vm.showDate,
      "showStartDate": _vm.showStartDate
    },
    on: {
      "filter": _vm.filter,
      "report": _vm.downloadReport
    }
  }), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("伺服器電腦時間")]), _c('th', [_vm._v("入口電腦時間")]), _c('th', [_vm._v("出口電腦時間")]), _c('th', [_vm._v("同步結果")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02e730b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ReportExport/TimeSyncSummary.vue
// module id = 1367
// module chunks = 1